import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getTDO(params) {
	return client.get("api/tdo/data", {
		params: params,
	});
}

function getTDOIn(params) {
	return client.get("api/tdo/data-in", {
		params: params,
	});
}

function getTDOOut(params) {
	return client.get("api/tdo/data-out", {
		params: params,
	});
}

function getTDOStatus() {
	return client.get("api/options/tdo-status");
}

function exportTDO(params) {
	return client.get("api/tdo/export", {
		params: params,
	});
}

function exportTDOIN(params) {
	return client.get("api/tdo/export-in", {
		params: params,
	});
}

function exportTDOOUT(params) {
	return client.get("api/tdo/export-out", {
		params: params,
	});
}

function getDetailTDO(params) {
	return client.get("api/tdo/detail", {
		params: {
			tdo_code: params
		},
	});
}

function createTDO (params) {
	return client.post("api/tdo/create", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function receiveTDO (params) {
	return client.post("api/tdo/receive", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getTDO,
	getTDOIn,
	getTDOOut,
	getTDOStatus,
	exportTDO,
	exportTDOIN,
	exportTDOOUT,
	getDetailTDO,
	createTDO,
	receiveTDO
};